// extracted by css-extract-rspack-plugin
export default {"root":"root-OfxCKm","card":"card-zxBVjn","back":"back-bQzvUp","id":"id-Eopt5I","label":"label-UicJfp","hint":"hint-JGBBRa","title":"title-eRaRCT"};